import React from 'react'

import { FilterBox } from '../../../../ui'

export const GuildFilters = () => {
  return <FilterBox />
}
